











































import { Component, Prop, Vue } from "vue-property-decorator";
import { KatalogItem } from "@/constants/geriatriOptions";

@Component
export default class CheckboxGroupBoolean extends Vue {
  @Prop({ default: () => ({}) }) readonly value!: Record<string, any>;
  @Prop({ default: () => [] }) readonly items!: KatalogItem[];
  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean;
  @Prop({ type: String, default: "" }) readonly lainnyaKey!: string;
  @Prop({ type: String, default: "" }) readonly lainnyaTextKey!: string;
  @Prop({ type: String, default: "Lainnya" }) readonly lainnyaLabel!: string;

  setNilai(key: string, nilai: any) {
    this.$set(this.value, key, nilai === undefined ? null : nilai);
    this.$emit("input", this.value);
  }
}
